import { Button, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Translate } from "../../../../Enums/Tranlate";

const ReasonModal = ({ modal, setModal, reason }) => {
	const lang = useSelector((state) => state.auth.lang);

	return (
		<Modal
			className={lang === "en" ? "en fade addProduct" : "ar fade addProduct"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={modal}
			onHide={() => {
				setModal();
			}}>
			<Modal.Header>
				<Modal.Title>{Translate[lang]?.reason} </Modal.Title>
				<Button
					variant=""
					className="close"
					style={{
						right: lang === "en" ? "0" : "auto",
						left: lang === "ar" ? "0" : "auto",
					}}
					onClick={() => {
						setModal();
					}}>
					<span>&times;</span>
				</Button>
			</Modal.Header>
			<Modal.Body>
				<h4>{reason}</h4>
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={setModal} variant="danger light" className="w-100">
					{Translate[lang]?.close}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default ReasonModal;
